import {
  BaseRecord,
  HttpError,
  useCustomMutation,
  useTranslate,
} from "@refinedev/core";
import { ChangePasswordForm } from "types";
import { shouldSuppressErrorToast } from "../helpers";

export const useChangePassword = () => {
  const t = useTranslate();
  const { mutateAsync: changePasswordMutate, isPending: isLoading } =
    useCustomMutation<BaseRecord, HttpError, ChangePasswordForm>();

  const changePassword = async (values: ChangePasswordForm) => {
    return await changePasswordMutate({
      url: "/api/users/change_password",
      method: "post",
      values,
      successNotification: {
        type: "success",
        message: t("pages.user.changePassword.passwordChanged"),
      },
      errorNotification: (error) =>
        shouldSuppressErrorToast(error)
          ? false
          : {
              type: "error",
              message: t("pages.user.changePassword.failedToChangePassword"),
            },
    });
  };

  return {
    changePassword,
    isLoading,
  };
};
